import React, { useState, useEffect, useRef } from "react";
import apiService from "../../../../ApiService"; // your API service abstraction
import { API_ENDPOINTS } from "../../../../ApiService";
import { MainContainer } from "../../styles/sharedStyles";
import Title from "../../../components/title/Title";
import Section from "../../../components/section/Section";
import { tokens } from "../../../../theme";

import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  Divider,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import InfoTextFieldWithDialog from "../../../components/tooltip/infoTextFieldWithDialog/InfoTextFieldWithDialog";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import MacroPieChart from "../../../components/charts/pieChart/MacroPieChart";
import NutritionCalculatorForm from "../../../components/nutrition/NutritionCalculatorForm";

const NutritionProgramPageDebutCoaching = () => {
  return <NutritionCalculatorForm showClientSelection={true} />;
};

export default NutritionProgramPageDebutCoaching;
